import { AdminState } from './types'
import { Module } from 'vuex'
import { RootState } from '@/Common/store/types'
import { actions } from './actions'
import { getters } from './getters'
import { mutations } from './mutations'
import { state } from './state'

const namespaced: boolean = true

export const admin: Module<AdminState, RootState> = {
  namespaced,
  state,
  mutations,
  getters,
  actions,
}
